<template>
  <es-form :padding="{ padding: '0 1.15rem 1.15rem 1.15rem' }">
    <template #es-form>
      <div class="row removeUnderline">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">
              Upload Type
            </label>
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <div class="buttons has-addons">
                  <button
                    v-for="(item, index) in uploadTypeOptions"
                    :key="index"
                    class="button button--form"
                    @click="selectType( 'uploadType', item.option )"
                    :class="{'is-active': formOptions.uploadType === item.option}"
                    style="min-width: 100px"
                  >
                    {{ item.label }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="formOptions.uploadType === 'ADVANCED'">
        <div class="row removeUnderline">
          <div class="field is-horizontal ">
            <div class="field-label is-normal">
              <label class="label">
                File Format
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <button
                      v-if="fileFormatOptions.length > 1"
                      v-for="(item, index) in fileFormatOptions"
                      :key="index"
                      class="button button--form"
                      @click="selectType( 'fileFormat', item.option )"
                      :class="{'is-active': formOptions.fileFormat === item.option}"
                      style="min-width: 100px"
                      disabled
                    >
                      {{ item.label }}
                    </button>
                    <label
                    v-if="fileFormatOptions.length = 1"
                    class="field"
                    v-for="(item, index) in fileFormatOptions"
                    :key="index"
                    style="padding-top: 5px; padding-left: 3px"
                    >
                      {{ item.label }}
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Delimiter
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <button
                      v-for="(item, index) in delimiterOptions"
                      :key="index"
                      class="button button--form"
                      @click="selectType( 'delimiter', item.option )"
                      :class="{'is-active': formOptions.delimiter === item.option}"
                      style="min-width: 100px"
                    >
                      {{ item.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Qualifier
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <button
                      v-for="(item, index) in qualifierOptions"
                      :key="index"
                      class="button button--form"
                      @click="selectType( 'qualifier', item.option )"
                      :class="{'is-active': formOptions.qualifier === item.option}"
                      style="min-width: 155px"
                    >
                      {{ item.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label" :aria-label="getFieldLabel(`PER:${defaultPersonType}:ASSIGN:SOURCE_CODE`)">
                {{ getFieldLabel(`PER:${defaultPersonType}:ASSIGN:SOURCE_CODE`) }}
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <es-select
                    v-on:update:values="formOptions.sourceInput = $event"
                    valueTpl="${description}"
                    :preSelected="sourceInput"
                    :set-values="activeSources"
                    ref="selSource"
                    keyValue="code"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row removeUnderline">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">
                Ignore First Row
              </label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="buttons has-addons">
                    <button
                      v-for="(item, index) in yesNoOptions"
                      :key="index"
                      class="button button--form"
                      @click="selectType( 'ignoreFirstRow', item.option )"
                      :class="{'is-active': formOptions.ignoreFirstRow === item.option}"
                      style="min-width: 50px"
                    >
                      {{ item.label }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </template>
    </template>
  </es-form>
</template>

<script>
import {
  mapGetters,
  mapActions
} from 'vuex';
import FieldLabels from '@/mixins/FieldLabels';
import NotificationManager from '@/mixins/NotificationManager';
import PermissionManager from '@/mixins/PermissionManager';
import EsForm from '@/components/EsForm.vue';
import EsSelect from '@/components/EsSelect.vue';

export default {
  props: {
    formOptions: {
      type: Object,
    },
    mulLocFile: {
      type: Boolean,
    },
  },
  mixins: [
    FieldLabels,
    NotificationManager,
    PermissionManager,
  ],
  components: {
    EsForm,
    EsSelect,
  },
  data() {
    return {
      sourceInput: null,
      delimiterOptions: [],
      fileFormatOptions: [],
      qualifierOptions: [],
      uploadTypeOptions: [],
      yesNoOptions: [],
    };
  },
  async created() {
    await this.loadPersonTypes();
    this.setDataElements();
  },
  computed: {
    ...mapGetters('lookups', [
      'activeSources',
      'defaultPersonType',
    ]),
  },
  methods: {
    ...mapActions('lookups', [
      'loadPersonTypes',
    ]),
    selectType(field, option) {
      this.formOptions[field] = option;
    },
    setDataElements() {
      this.sourceInput = this.activeSources.filter(s => s.isDefault === true);
      this.delimiterOptions = [
        {
          label: 'Tab',
          option: 'TAB',
        },
        {
          label: 'Comma',
          option: 'COMMA',
        },
      ];
      this.fileFormatOptions = [
        // {
        //   label: 'Version 1.0',
        //   option: '1.0',
        // },
        // {
        //   label: 'Version 2.1',
        //   option: '2.1',
        // },
        {
          label: 'Version 3.0',
          option: '3.0',
        },
      ];
      this.qualifierOptions = [
        {
          label: 'Double Quotes ( " )',
          option: 'DOUBLE_QUOTES',
        },
        // We may need Single Quote back in the future.
        /*
        {
          label: "Single Quote ( ' )",
          option: 'SINGLE_QUOTES',
        },
        */
        {
          label: 'None',
          option: 'NONE',
        },
      ];
      this.yesNoOptions = [
        {
          label: 'Yes',
          option: true,
        },
        {
          label: 'No',
          option: false,
        },
      ];
      this.uploadTypeOptions = [
        {
          label: 'Simple',
          option: 'SIMPLE',
        },
        {
          label: 'Advanced',
          option: 'ADVANCED',
        },
      ];
    },
  },
};
</script>

<style lang="sass" scoped>
</style>
